import Vue from 'vue'
import Router from 'vue-router'
import { state as AppState, restoreScroll } from './api/api'
// import Home from './views/Home.vue'

Vue.use(Router)

let requireLogin = (to, from, next) => {
  if (to.query.redirect) {
    next(to.query.redirect)
  } else if (AppState.me) {
    next()
  } else {
    next(`/login${to.query.redirect ? '?redirect=' + encodeURIComponent(to.query.redirect) : ''}`)
  }
}
let goHomeIfLoggedIn = (to, from, next) => {
  if (AppState.me.user) {
    next('/app/home')
  } else {
    next()
  }
}

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/',
      beforeEnter: goHomeIfLoggedIn,
      component: () => import(/* webpackChunkName: "main" */ './pages-main/Landing.vue')
    },
    {
      path: '/feed',
      component: () => import(/* webpackChunkName: "feed" */ './uis-feed/EnergyCanvas.vue')
    },

    {
      path: '/login',
      component: () => import(/* webpackChunkName: "main" */ './pages-main/Login.vue')
    },
    {
      path: '/register',
      component: () => import(/* webpackChunkName: "main" */ './pages-main/Register.vue')
    },
    {
      path: '/app',
      beforeEnter: requireLogin,
      component: () => import(/* webpackChunkName: "proto" */ './pages-app/pages/Proto.vue'),
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'explore',
          component: () => import(/* webpackChunkName: "explore" */ './pages-app/pages/Explore.vue')
        },
        {
          path: 'home',
          component: () => import(/* webpackChunkName: "home" */ './pages-app/pages/Home.vue')
        },
        {
          path: 'menu',
          component: () => import(/* webpackChunkName: "menu" */ './pages-app/pages/Menu.vue')
        },
        {
          path: 'notification',
          component: () => import(/* webpackChunkName: "notification" */ './pages-app/pages/Notification.vue')
        },
        {
          path: 'composer',
          component: () => import(/* webpackChunkName: "composer" */ './pages-app/pages/Composer.vue')
        },
        {
          path: 'network',
          component: () => import(/* webpackChunkName: "react-network" */ './pages-app/pages/ReactNetwork.vue')
        },
        {
          path: 'postID/:postID',
          component: () => import(/* webpackChunkName: "postdetail" */ './pages-app/pages/Detail.vue')
        }
      ]
    }
  ]
})

router.afterEach(() => {
  restoreScroll()
  setTimeout(() => {
    restoreScroll()
  }, 20)
  setTimeout(() => {
    restoreScroll()
  }, 100)
})

export default router
